import store from "./store";
import router from "./router";
import axios from "axios";
import { showToast, showConfirmDialog } from "vant";
import i18n from "./i18n";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";

const instance = axios.create({
  baseURL: CONFIG.DOMAIN.PROXY_API_ACTIVITY,
  timeout: 30000,
});

// 添加请求拦截器
instance.interceptors.request.use(
  async (config) => {
    // 在发送请求之前做些什么
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const {
      data: { error, msg },
      config: { errorToastShown = false } = {},
    } = response;
    if (errorToastShown && error) {
      if (error === 3) {
        // 金币不够错误在业务端处理
        throw new Error("balance not enought!");
      }
      const message =
        `
      <h3>Please contact our CS</h3>` +
        `<p>Error Code: ${error}</p>` +
        (msg ? `<p>Error Message: ${msg}</p>` : "");
      showToast({ message, duration: 5000 });
    }
    return response;
  },
  (error) => {
    const { config: { errorToastShown = false } = {} } = error;
    // 对响应错误做点什么
    if (errorToastShown) {
      const message =
        `
      <h3>Please contact our CS</h3>` +
        (error.code ? `<p>Error Code: ${error.code}</p>` : "") +
        (error.message ? `<p>Error Message: ${error.message}</p>` : "");
      showToast({ message, duration: 5000 });
    }
    return Promise.reject(error);
  }
);

// const payHost = process.env.VUE_APP_YOHO_PAY_API
export const payAxios = axios.create({
  baseURL: CONFIG.DOMAIN.PAY_API,
  timeout: 30000,
});

// 添加请求拦截器
payAxios.interceptors.request.use(
  async (config) => {
    const token = await store.dispatch("getToken");
    // console.log("token", token);
    if (!token) {
      return showConfirmDialog({
        // title: 'OK',
        message: i18n["session-timeout-tip"],
        confirmButtonText: i18n.common_confirm,
        cancelButtonText: i18n.common_cancel,
      }).then(() => {
        // on close
        return router.replace({
          name: "login",
          replace: true,
        });
      });
    }
    if (!store?.getters?.profile) {
      await store.dispatch("setProfile");
      router.push({
        name: "login",
      });
      return Promise.reject({ message: "please login again!" });
    }
    // 在发送请求之前做些什么
    // if (/POST/i.exec(config.method)) {
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // }
    config.headers["Grpc-Metadata-appid"] = "Web-OnLineCharge";
    config.headers["Grpc-Metadata-pdid"] = 1007;
    config.headers["Grpc-Metadata-did"] =
      "362f864b-d48c-41cc-84b0-f1fa42450df1";
    config.headers["Grpc-Metadata-uid"] = store.getters.profile.uid;
    config.headers["Grpc-Metadata-pcred"] = token;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
payAxios.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response;
  },
  (error) => {
    let message = "";
    // 对响应错误做点什么
    if (error?.response?.data) {
      message =
        error?.response?.data?.code + " - " + error?.response?.data?.message;
    } else {
      message =
        "Oops! Something error" +
        (error.message ? `, error message: ${error.message}` : "");
    }
    showToast({ message, duration: 5000 });
    return Promise.reject(error);
  }
);

export default instance;
